import { createContext } from 'libs/react';
import { useContext } from 'libs/react';
import { useEffect } from 'libs/react';
import { useState } from 'libs/react';
import { UnexpectedError } from 'libs/error/UnexpectedError';
import { React } from 'libs/react';
/**
 * @component BreakpointProvider
 * @since 1.0.0
 */
export function BreakpointProvider(props) {
    const [value, setValue] = useState('xs');
    const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
    const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
    /**
     * @function each
     * @since 1.0.0
     * @hidden
     */
    function each(a, b, callback) {
        if (a <= b) {
            for (let i = a; i < b; i++) {
                callback(i, medias[i + 1][NAME], medias[i + 0][NAME]);
            }
        }
        else {
            for (let i = a; i > b; i--) {
                callback(i, medias[i - 1][NAME], medias[i - 0][NAME]);
            }
        }
    }
    /**
     * @function enter
     * @since 1.0.0
     * @hidden
     */
    function enter(name) {
        document.documentElement.classList.toggle(name, true);
    }
    /**
     * @function leave
     * @since 1.0.0
     * @hidden
     */
    function leave(name) {
        document.documentElement.classList.toggle(name, false);
    }
    useEffect(() => {
        /**
         * @function onResize
         * @since 1.0.0
         * @hidden
         */
        function onResize() {
            setViewportWidth(window.innerWidth);
            setViewportHeight(window.innerHeight);
        }
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    });
    useEffect(() => {
        let found = null;
        for (const entry of medias) {
            const [name, size] = entry;
            const query = `(max-width: ${size}px)`;
            const match = matchMedia(query).matches;
            if (match) {
                found = name;
            }
        }
        if (found == null || found == value) {
            return;
        }
        let a = null;
        let b = null;
        for (let i = 0; i < medias.length; i++) {
            const name = medias[i][NAME];
            if (name == value)
                a = i;
            if (name == found)
                b = i;
        }
        if (a == null || b == null) {
            throw new UnexpectedError();
        }
        each(a, b, (i, e, l) => {
            leave(l);
            enter(e);
        });
        setValue(found);
    }, [viewportWidth, viewportHeight]);
    const context = {
        get breakpoint() {
            return value;
        },
        isAbove(breakpoint) {
            return orders[value] > orders[breakpoint];
        },
        isBelow(breakpoint) {
            return orders[value] < orders[breakpoint];
        },
        isAboveOrEqual(breakpoint) {
            return orders[value] >= orders[breakpoint];
        },
        isBelowOrEqual(breakpoint) {
            return orders[value] <= orders[breakpoint];
        }
    };
    return (React.createElement(BreakpointContext.Provider, { value: context }, props.children));
}
const NAME = 0;
const SIZE = 1;
/**
 * @const medias
 * @since 1.0.0
 */
const medias = Object.entries({
    'xxl-2160': 3840,
    'xxl-1440': 2556,
    'xxl-1080': 1920,
    xxl: 1600,
    xl: 1440,
    lg: 1024,
    md: 768,
    sm: 575,
    xs: 375
});
/**
 * @const orders
 * @since 1.0.0
 */
const orders = {
    'xxl-2160': 8,
    'xxl-1440': 7,
    'xxl-1080': 6,
    xxl: 5,
    xl: 4,
    lg: 3,
    md: 2,
    sm: 1,
    xs: 0
};
/**
 * @component BreakpointContext
 * @since 1.0.0
 */
export const BreakpointContext = createContext({
    breakpoint: '',
    isAbove: () => false,
    isBelow: () => false,
    isAboveOrEqual: () => false,
    isBelowOrEqual: () => false
});
/**
 * @component useBreakpoint
 * @since 1.0.0
 */
export function useBreakpoint() {
    return useContext(BreakpointContext);
}
/**
 * @function breakpoints
 * @since 1.0.0
 * @hidden
 */
function sort(breakpoints) {
    return breakpoints.sort((a, b) => {
        const aIndex = orders[a];
        const bIndex = orders[b];
        return aIndex - bIndex;
    });
}
